import React, { useState } from 'react';
import {
  Typography,
  Button,
  Grid,
  Paper,
  TextField,
  MenuItem
} from '@mui/material';
import CourierLayout from '../CourierLayout'; // Adjust path as needed

const CourierLanguageAndLocalization = () => {
  const [selectedLanguage, setSelectedLanguage] = useState('');

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  const handleSave = () => {
    console.log('Language saved:', selectedLanguage);
    alert('Settings saved!');
  };

  return (
    <CourierLayout>
      <Typography variant="h4" gutterBottom>
        Language and Localization
      </Typography>

      <Typography variant="body1" gutterBottom>
        Customize your language and localization settings.
      </Typography>

      {/* Language Selection */}
      <Paper elevation={2} style={{ padding: '20px', marginBottom: '30px' }}>
        <Typography variant="h6" gutterBottom>Language Selection</Typography>
        <TextField
          select
          label="Select Language"
          value={selectedLanguage}
          onChange={handleLanguageChange}
          variant="outlined"
          fullWidth
          size="small"
        >
          <MenuItem value="English">English</MenuItem>
          <MenuItem value="Spanish">Spanish</MenuItem>
          <MenuItem value="French">French</MenuItem>
          <MenuItem value="Russian">Russian</MenuItem>
          <MenuItem value="Tatar">Tatar</MenuItem>
          <MenuItem value="Arabic">Arabic</MenuItem>
          <MenuItem value="Chinese">Chinese</MenuItem>
          <MenuItem value="German">German</MenuItem>
        </TextField>
      </Paper>

      {/* Localization Placeholder */}
      <Paper elevation={2} style={{ padding: '20px', marginBottom: '30px' }}>
        <Typography variant="h6" gutterBottom>Localization Options</Typography>
        <Typography variant="body2" color="textSecondary">
          (Coming soon: region, currency, timezone...)
        </Typography>
      </Paper>

      <Button variant="contained" color="primary" onClick={handleSave}>
        Save Settings
      </Button>
    </CourierLayout>
  );
};

export default CourierLanguageAndLocalization;
